import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import FeatureToggle from '../../../../components/FeatureToggle';
import FileIntegrationTypes from '../../../../components/FileIntegrationTypes';
import IntegrationTypes from '../../../../components/IntegrationTypes';

import './CompanyAddOns.scss';

export class CompanyAddOns extends React.Component {

  constructor(props) {
    super(props);
    this.userCanEdit = this.userCanEdit.bind(this);
  }

  userCanEdit() {
    return (this.props.permissions.isSuperUser);
  }

  render() {
    const { company } = this.props;
    if (!company) {
      return null;
    }
    const isReadOnly = !this.userCanEdit();

    return (
      <div className="company-addons">
        <FeatureToggle 
          company={company}
          description={'Configuring Active Oversight to save work documentation to your external document repository automatically.'}
          featureName={'file_integration'}
          readOnly={isReadOnly}
          title={'Document Storage'}
        >
          <FileIntegrationTypes
            company={company}
          />
        </FeatureToggle>
        <FeatureToggle 
          company={company}
          description={'Empower your workers with internationalized content. Supported languages include Español, Português, and Pусский.'}
          featureName={'internationalization'}
          readOnly={isReadOnly}
          title={'Internationalization'}
        />
        <FeatureToggle 
          company={company}
          description={'Scan in equipment and materials right from the field and then view inventory reports on your web app and your Closeout document.'}
          featureName={'inventory'}
          readOnly={isReadOnly}
          title={'Inventory'}
        />
        <FeatureToggle
          company={company}
          description={'Navigate and complete Tasks through the Active Oversight mobile app with device tilt and speech commands.'}
          featureName={'hands_free'}
          readOnly={isReadOnly}
          title={'Hands-Free'}
        />
        <FeatureToggle
          company={company}
          description={'Delay organisation settings'}
          featureName={'delay_enabled'}
          readOnly={isReadOnly}
          title={'Delay Setting'}
        />
        <FeatureToggle
          company={company}
          description={'Improve inaccuracies, streamline financial workflows and eliminate manual progress tracking and redundant data synchronization.'}
          featureName={'integration'}
          readOnly={isReadOnly}
          title={'Project Management Tool'}
        >
          <IntegrationTypes
            company={company}
          />
        </FeatureToggle>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
  };
};

export default connect(mapStateToProps)(CompanyAddOns);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/CompanyCRUD/CompanyAddOns/index.js